import { useAuthContext } from "@features/auth/contexts/AuthContext";
import { AppBar } from "@features/dashboard/layouts/AppBar";
import { titleCase } from "@memorang/helpers/common";
import type { ExamInfoStat } from "@memorang/ui/components/HomeApplet/ExamInfoCard";
import type { TasksSectionItem } from "@memorang/ui/components/HomeApplet/types";
import { LessonsHomeScreen } from "@memorang/ui/components/LessonsHomeScreen/LessonsHomeScreen";
import { useRouter } from "expo-router";
import { useTranslation } from "react-i18next";
import {
	allModules,
	moduleHomeDistribution,
	moduleHomeInsight,
	moduleHomeStats,
	moduleHomeSubtitle,
	suggestedModules,
} from "../constants";
import { toExploreLessons } from "../helpers";

export const ModulesContainer = () => {
	const router = useRouter();
	const { t } = useTranslation();
	const { firstName } = useAuthContext();

	const handleOpenModule = ({ id }: { id: string }) => {
		router.push(`/modules/${id}`);
	};

	const stats: ExamInfoStat[] = [
		{
			icon: "check-circle-outline",
			label: t("lessons.home.stats.modulesDone"),
			value: String(moduleHomeStats.modulesDone),
		},
		{
			icon: "calendar-check-outline",
			label: t("lessons.home.stats.dayStreak"),
			value: String(moduleHomeStats.dayStreak),
		},
		{
			icon: "timer-outline",
			label: t("lessons.home.stats.minutesToday"),
			value: String(moduleHomeStats.minutesToday),
		},
	];

	const suggestedTasks: TasksSectionItem[] = suggestedModules.map((module) => {
		const started = module.completionPercent > 0;
		return {
			title: module.title,
			body: module.description,
			status: started ? "ACTIVE" : "NOT_STARTED",
			completion: module.completionPercent,
			ringLabel: started
				? t("lessons.home.suggested.status.ready")
				: t("lessons.home.suggested.status.next"),
			ctaLabel: started ? undefined : t("lessons.home.suggested.openModuleCta"),
			chips: [
				{ label: module.specialty },
				{
					label: t("lessons.home.card.duration", {
						count: module.durationMinutes,
					}),
				},
			],
			onPress: () => handleOpenModule(module),
		};
	});

	return (
		<>
			<AppBar title="Modules" />
			<LessonsHomeScreen
				hero={{
					userName: firstName ? titleCase(firstName) : undefined,
					subtitle: moduleHomeSubtitle,
					distribution: moduleHomeDistribution,
					stats,
					insight: moduleHomeInsight,
				}}
				suggestedLessons={suggestedTasks}
				allLessons={toExploreLessons(allModules)}
				allLessonsTitle="All modules"
				onLessonPress={handleOpenModule}
			/>
		</>
	);
};
